import ApexCharts from 'apexcharts';
import React, { useEffect, useRef } from 'react';

const Chart = ({ options, series, style, height = 'auto', width = '100%' }) => {
  const chartContainerRef = useRef();

  useEffect(() => {
    const chart = new ApexCharts(chartContainerRef.current, {
      series: series,
      ...options,
      chart: {
        ...options.chart,
        height,
        width,
      },
    });
    chart.render();
    return () => {
      chart.destroy();
    };
  }, [options, series, height, width]);

  return <div ref={chartContainerRef} style={style}></div>;
};

export default Chart;